// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-Sort {
  width: 75px;
  max-width: 75px;
  min-width: 75px;
}

.mat-column-Positionsgrupper {
  min-width: 140px;
  max-width: 220px;
}

.mat-column-Bezeichnung {
  min-width: 240px;
}

.mat-column-Menge {
  min-width: 80px;
  max-width: 80px;
}

.mat-column-Einheit {
  min-width: 125px;
  max-width: 125px;
}

.mat-column-Einheitspreis {
  min-width: 100px;
  max-width: 100px;
}

.mat-column-Angebotspreis {
  min-width: 100px;
  max-width: 100px;
}

.mat-column-Abzug_Vorschaeden {
  min-width: 75px;
  max-width: 75px;
}

.mat-column-AngebotspreisZeit {
  min-width: 100px;
  max-width: 100px;
}

.mat-column-UStVorhanden {
  min-width: 60px;
  max-width: 60px;
}

.mat-column-Abloese {
  min-width: 60px;
  max-width: 60px;
}

.mat-column-Eigenleistung {
  min-width: 65px;
  max-width: 65px;
}

.mat-column-actions {
  width: 220px;
  max-width: 220px;
  min-width: 220px;
  z-index: 2 !important;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/kalkulation/kalkulation.page.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;AACF","sourcesContent":[".mat-column-Sort {\n  width: 75px;\n  max-width: 75px;\n  min-width: 75px;\n}\n\n.mat-column-Positionsgrupper {\n  min-width: 140px;\n  max-width: 220px;\n}\n\n.mat-column-Bezeichnung {\n  min-width: 240px;\n}\n\n.mat-column-Menge {\n  min-width: 80px;\n  max-width: 80px;\n}\n\n.mat-column-Einheit {\n  min-width: 125px;\n  max-width: 125px;\n}\n\n.mat-column-Einheitspreis {\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.mat-column-Angebotspreis {\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.mat-column-Abzug_Vorschaeden {\n  min-width: 75px;\n  max-width: 75px;\n}\n\n.mat-column-AngebotspreisZeit {\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.mat-column-UStVorhanden {\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.mat-column-Abloese {\n  min-width: 60px;\n  max-width: 60px;\n}\n\n.mat-column-Eigenleistung {\n  min-width: 65px;\n  max-width: 65px;\n}\n\n.mat-column-actions {\n  width: 220px;\n  max-width: 220px;\n  min-width: 220px;\n  z-index: 2 !important;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
